import { Component, type JSX } from 'react';
import styled from 'styled-components';
import { createMarkup } from 'lib/utils/create-markup';
import { SitePopup as SitePopupStyle } from 'components/styles/site-popup';
import Svg from 'lib/svgs.json';

const SitePopupContainer = styled.div`
  ${SitePopupStyle}
`;

type Props = {
  id: string;
  children: JSX.Element;
  type: string;
};

type State = any;

/*
The id of this component can be used to link a button to the
popup in Contentful.

For example, on the DS01 page, the "Learn More" button is in
Contentful with "modal-sustainability" in the  modal text
entry. That is how it opens <ModalSustainability />, as it
is wrapped in a <SitePopup /> with id="modal-sustainability".
*/

class SitePopup extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal() {
    const event = new CustomEvent('popup_close', { detail: this.props.id });
    window.dispatchEvent(event);
  }

  render() {
    const { id, children, type } = this.props;

    const classnames = {
      drawer: ' site-popup-drawer',
      modal: ' site-popup-modal',
    };

    return (
      <SitePopupContainer>
        <div id={id} data-no-print className={`site-popup${classnames[type]}`}>
          {}
          <div onClick={this.handleCloseModal} className='site-popup-bg' />

          <div className='site-popup-card'>
            <div className='container'>{children}</div>

            <button
              onClick={this.handleCloseModal}
              className='site-popup-exit'
              aria-label='Close popup'
              dangerouslySetInnerHTML={createMarkup(Svg.cross)}
              type='button'
            />
          </div>
        </div>
      </SitePopupContainer>
    );
  }
}

export default SitePopup;
